module.exports = __webpack_public_path__ + "static/img/MANHATTAN-OAK.50cf3f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/MANHATTAN-OAK.png
// module id = +E2z
// module chunks = 0